<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="toc1"><a id="page_v"></a><a href="#/xhtml/06_Fm01"><i>Translator’s Note</i></a></p>
<p class="toc"><a href="#/xhtml/08_Introduction">Introduction</a></p>
<p class="toc1"><span href="#/xhtml/09_Chapter01" title="Link target outside of Sample">The Letters</span></p>
<p class="toc"><span href="#/xhtml/10_Notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc"><span href="#/xhtml/11_Bm01" title="Link target outside of Sample"><i>List of Names</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?70a3f3cf